export function checkUnsavedChangesNewFile({
  reportCreatedTime,
  reportChangedTime,
  reportSavedTime,
}: {
  reportCreatedTime: number;
  reportChangedTime: number;
  reportSavedTime: number;
}) {
  // no changes
  if (reportCreatedTime === reportChangedTime) return false;
  // has changes, but no save has been made yet.
  if (reportChangedTime > reportSavedTime) return true;

  return false;
}

export function checkUnsavedChangesExistedFile({
  reportCreatedTime,
  reportChangedTime,
  reportSavedTime,
}: {
  reportCreatedTime: number;
  reportChangedTime: number;
  reportSavedTime: number;
}) {
  const hasChanges = reportChangedTime > reportCreatedTime;
  const changesNotSaved = reportChangedTime >= reportSavedTime;

  return hasChanges && changesNotSaved;
}
